import React, { useState, useEffect } from 'react';
import nftImg from '../assets/img/gif.gif';
import copyIcon from '../assets/img/Copy.png';
import { useCommonStats, useAccountStats } from '../hooks/useStats';
import { useWeb3React } from "@web3-react/core";
import { contract, DEFAULT_CHAIN, trimAddress } from '../hooks/constant';
import { supportNetwork } from '../hooks/network';
import { formatPrice, getContract } from '../hooks/contractHelper';
import { toast } from 'react-toastify';
import nftAbi from '../json/nftAbi.json';
import { parseUnits } from 'ethers/lib/utils';
import { getWeb3 } from '../hooks/connectors';
import logoImg from '../assets/img/logo.png';
import Connect from './Connect';
import { Link, useLocation } from 'react-router-dom';
import { CopyToClipboard } from "react-copy-to-clipboard";
import { CardConnect } from './CardConnect';
import localStorage from 'local-storage';





export default function Mint() {
    const { account, chainId, library } = useWeb3React();
    const [updater, setUpdater] = useState(new Date());
    const commonStats = useCommonStats(updater);
    const accStats = useAccountStats(updater);
    const [amount, setAmount] = useState(0);
    const [totalCost, setTotalCost] = useState(0);
    const [loading, setLoading] = useState(false);
    const [referrallink, setReferrallink] = useState(
        "Please connect your wallet"
    );
    const [refcopy, setRefcopy] = useState(false);
    let base_url = `${window.location.origin}?ref=`;

    useEffect(() => {
        setTotalCost(commonStats.cost * amount);
        // eslint-disable-next-line
    }, [amount]);

    const search = useLocation().search;

    useEffect(() => {
        const refAdd = new URLSearchParams(search).get('ref');
        var now = new Date().getTime();
        if (refAdd) {
            localStorage.set('ref', refAdd);
            localStorage.set('setupTime', now)
        }
        let lastAddr = localStorage.get('ref');
        if (!refAdd && lastAddr !== null) {



            var setupTime = localStorage.get('setupTime');
            if (setupTime == null) {
                localStorage.set('setupTime', now)
            } else {
                if (now - setupTime > 86400 * 1000) {
                    localStorage.remove('ref');
                    localStorage.set('setupTime', now);
                }
            }
        }

    }, [search]);

    useEffect(() => {
        if (account) {
            setReferrallink(`${base_url}${account}`);
        } else {
            setReferrallink("Please connect your wallet");
        }
    }, [account, base_url]);




    const handleMint = async () => {
        try {
            setLoading(true);
            if (account) {
                if (chainId === DEFAULT_CHAIN) {
                    if (parseInt(amount) > 0) {
                        let nftContract = getContract(nftAbi, contract[DEFAULT_CHAIN].NFT_ADDRESS, library);
                        let last_ref = localStorage.get('ref');
                        let refAddr = last_ref !== null ? last_ref : '0x0000000000000000000000000000000000000000';
                        console.log(refAddr);
                        let tx = await nftContract.publicMint(refAddr, amount, { 'from': account, value: parseUnits(totalCost.toString(), 18) });
                        toast.loading('Waiting for confirmation...');
                        var interval = setInterval(async function () {
                            let web3 = getWeb3(DEFAULT_CHAIN);
                            var response = await web3.eth.getTransactionReceipt(tx.hash);
                            if (response != null) {
                                clearInterval(interval)
                                if (response.status === true) {
                                    toast.dismiss();
                                    toast.success('Your last transaction is a success!');
                                    setLoading(false);
                                    setUpdater(new Date());


                                }
                                else if (response.status === false) {
                                    toast.dismiss();
                                    toast.error('error ! Your last transaction failed.');
                                    setLoading(false);
                                }
                                else {
                                    toast.dismiss();
                                    toast.error('error ! Something went wrong.');
                                    setLoading(false);
                                }
                            }
                        }, 5000);
                    }
                    else {
                        toast.error('please select a valid mint amount!');
                        setLoading(false);
                    }

                }
                else {
                    toast.error('Please connect to Mainnet!');
                    setLoading(false);
                }
            }
            else {
                toast.error('Please connect wallet!');
                setLoading(false);
            }
        }
        catch (err) {
            toast.error(err.reason ? err.reason : err.message);
            setLoading(false);
        }
    }


    return (
        <div className="min-h-screen h-full w-full flex flex-col bg-brand-light overflow-hidden">
            <header className="min-w-full text-gray-800 py-2 px-3 md:px-0">
                <div className="flex items-center container mx-auto max-w-5xl justify-between ">
                    {/* Logo */}
                    <Link to="/" className="">
                        <img src={logoImg} className="w-25 h-25 pt-2" alt="logo-img" />
                    </Link>

                    {/* Opensea Twitter Discord Links */}
                    <nav aria-label="Contact Menu">
                        <ul className="flex items-center space-x-4 md:space-x-6">
                            <li className="cursor-pointer">
                                <Connect />
                            </li>
                        </ul>
                    </nav>
                </div>
            </header>
            <div className="relative w-full h-full flex flex-col items-center justify-center mb-5">
                {/* <img
                    alt="bulr-img"
                    src={bulrImg}
                    className="animate-pulse-slow absolute inset-auto block w-full min-h-screen object-cover"
                /> */}

                <div className="flex flex-col items-center justify-center h-full w-full px-2 md:px-10 ms-10">
                    <div className="relative z-1 w-50 w-full bg-gray-900/90 filter backdrop-blur-sm py-4 rounded-md px-2 md:px-10 ">
                        <h1 className="text-center font-coiny uppercase font-bold text-2xl md:text-2xl text-white from-brand-green ps-4 pt-2 pb-3">
                            {/* {paused ? 'Paused' : isPreSale ? 'Pre-Sale' : 'Public Sale'}  */}
                            Mint your own exclusive Astro Token
                        </h1>
                        
                        <div className='d-flex justify-content-between mt-3 ps-5'>
                            {account &&
                                <h3 className="text-sm text-white tracking-widest">
                                    <span className='head-text-level'> Account Address :</span>
                                    <span className='h6 '> {trimAddress(account)}</span><br />
                                    <span className='head-text-level'>Account Level :</span>
                                    <span className='h6'> {accStats.refCount && (parseFloat(accStats.refCount) <= 5) ? 'Level 1' : (parseFloat(accStats.refCount) > 5 && parseFloat(accStats.refCount) <= 10) ? 'Level 2' : parseFloat(accStats.refCount) > 10 ? 'Level 3' : '-'}</span><br />


                                </h3>
                            }
                        </div>

                        <div className="flex flex-col md:flex-row md:space-x-16 space-y-10 ps-3 items-center m-3 w-full pt-3">
                        {/* BoredApe Image */}
                        <img
                            alt="nft-img"
                            src={nftImg}
                            className="object-cover mint-img w-full sm:h-[300px] md:w-[250px] rounded-md2 "
                        />

                            <div className="flex flex-col items-center w-full px-4 mt-16 md:mt-0 pe-5">
                                <div className={`w-85 ${account ? 'right-box' : 'left-box'}`}>
                                    {account ? (
                                        <>
                                            <div className="font-coiny flex items-center justify-between w-full">
                                                <button
                                                    onClick={() => setAmount((prev) => prev > 0 ? prev - 1 : 0)}
                                                    className="flex items-center justify-center text-brand-background hover:shadow-lg bg-gray-300 font-bold rounded-md"
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="h-6 w-6 md:h-8 md:w-8"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="currentColor"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            strokeWidth={2}
                                                            d="M18 12H6"
                                                        />
                                                    </svg>
                                                </button>
                                                <p className="flex items-center justify-center flex-1 grow text-center font-bold text-3xl md:text-4xl">
                                                    {amount}
                                                </p>
                                                <button
                                                    onClick={() => setAmount((prev) => parseInt(prev + 1) <= parseFloat(commonStats.Max_Wallet) ? parseInt(prev + 1) : parseFloat(commonStats.Max_Wallet))}
                                                    className="flex items-center justify-center text-brand-background hover:shadow-lg bg-gray-300 font-bold rounded-md"
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        className="h-6 w-6 md:h-8 md:w-8"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="currentColor"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            strokeWidth={2}
                                                            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                                                        />
                                                    </svg>
                                                </button>
                                            </div>
                                            {/* <p className="text-sm tracking-widest mt-3">
                                                Max Mint Amount: {parseFloat(commonStats.Max_Wallet) - parseFloat(accStats.userMinted)}
                                            </p> */}

                                            <div className="py-4 mt-6 w-full">
                                                <div className="w-full text-xl font-coiny flex items-center justify-between mb-2">
                                                    <p className='fs-6'>Available Supply</p>

                                                    <div className="flex items-center space-x-3">
                                                        <p className='text-white fs-6'>{commonStats.totalSupply ? commonStats.totalSupply : 0} / {commonStats.MAX_SUPPLY ? commonStats.MAX_SUPPLY : 0}</p>
                                                    </div>
                                                </div>
                                                <div className="w-full text-xl font-coiny flex items-center justify-between mb-2">
                                                    <p className='fs-6'>Wallet Balance</p>

                                                    <div className="flex items-center space-x-3">
                                                        <p className='text-white fs-6'>{accStats.balanceOf ? accStats.balanceOf : 0}</p>
                                                    </div>
                                                </div>
                                                <div className="w-full text-xl font-coiny flex items-center justify-between">
                                                    <p className='fs-6'>Total Price</p>

                                                    <div className="flex items-center space-x-3">
                                                        <p className='text-white fs-6'>{totalCost ? formatPrice(totalCost) : 0} {supportNetwork[DEFAULT_CHAIN].symbol}</p>&nbsp;
                                                        <span class="text-gray-400"> + GAS</span>
                                                    </div>
                                                </div>

                                            </div>
                                        </>
                                    ) : (
                                        <div className="mt-1 w-full">
                                            <h1 className="text-center font-coiny uppercase font-bold mb-3 text-2xl md:text-2xl text-white from-brand-green">
                                                Public Sale
                                            </h1>
                                            <h6 className="font-coiny fs-7 text-white from-brand-green m-3">
                                                Sale is now live Mint your NFT below
                                            </h6>
                                        </div>
                                    )
                                    }
                                </div>
                                {account ? (
                                    <button
                                        onClick={() => handleMint()}
                                        className="mint-button third mt-70 mb-4"
                                        disabled={loading}
                                    >
                                        {loading ? `Loading...` : 'Mint'}
                                    </button>
                                ) : (
                                    <CardConnect />
                                )}

                            </div>
                        </div>
                        {/* <h4 className="font-coiny text-2xl text-dark uppercase mt-6 ps-4 text-center font-bold ">
                            Contract Address
                        </h4>
                        <a
                            href={`https://etherscan.io/address/${contract[DEFAULT_CHAIN].NFT_ADDRESS ? contract[DEFAULT_CHAIN].NFT_ADDRESS : ' - '}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="align-items-center flex justify-center font-bold text-black mt-2"
                        >
                            <span className="break-all ... ">{contract[DEFAULT_CHAIN].NFT_ADDRESS ? contract[DEFAULT_CHAIN].NFT_ADDRESS : ' - '}</span>
                        </a> */}
                        {account &&
                            <>
                                <h4 className="font-coiny text-2xl text-white uppercase mt-4 ps-4 text-center font-bold ">
                                    Referral Link
                                </h4>
                                <div className="input-group mx-3 my-3 ps-3">
                                    <input type="text" className="form-control" value={referrallink} />
                                    <span className="input-group-text" id="basic-addon2">
                                        <CopyToClipboard text={`${base_url}${account}`} onCopy={() => {
                                            setRefcopy(true);
                                            setTimeout(() => {
                                                setRefcopy(false);
                                            }, 2000)
                                        }}>
                                            <button className="button" type="button">
                                            <img
                                    src={copyIcon}
                                    alt="Icon"
                                />
                                            </button>
                                        </CopyToClipboard>
                                        <span>{refcopy && <div className="input-group text-white">‎ Copied </div>}</span>
                                    </span>
                                </div>
                            </>
                        }

                    </div>
                </div>
            </div>
        </div>

    )
}
